var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Hi-3")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Information you entered about yourself, your career, and your retirement planning is shown in the summary below.\n    These inputs, and how they may impact your pension under the Hi-3 retirement plan, are explained in the following\n    graphs and charts. Additional resources can be found at the end of this summary. All amounts are shown in future dollars.\n  "
      ),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "margin-top" }, [
      _c("h1", [_vm._v("Your Information")]),
      _vm._v(" "),
      _c("h2", [_vm._v("Personal Information")]),
      _vm._v(" "),
      _c(
        "ul",
        [
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("When were you born?"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(
                _vm._s(_vm._f("month")(_vm.formData.bornDateMonth)) +
                  " " +
                  _vm._s(_vm.formData.bornDateYear)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("What is your Pay Entry Base Date?"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(
                _vm._s(_vm._f("month")(_vm.formData.payEntryBaseDateMonth)) +
                  " " +
                  _vm._s(_vm.formData.payEntryBaseDateYear)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("What is your current grade?"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(_vm._s(_vm.formData.grade)),
            ]),
          ]),
          _vm._v(" "),
          _vm.showFor("ac2ac", "ac2rc")
            ? [
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v("What is your Active Service Date?"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("month")(_vm.formData.activeServiceDateMonth)
                      ) +
                        " " +
                        _vm._s(_vm.formData.activeServiceDateYear)
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v(
                "What is your estimate of service at separation or retirement?"
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(
                _vm._s(_vm.formData.retirementSTYears) +
                  " years " +
                  _vm._s(_vm.formData.retirementSTMonths) +
                  " months"
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.showFor("ac2rc")
            ? [
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v("When do you plan to join the Reserve component?"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(
                      _vm._s(_vm.formData.transferToRcYears) +
                        " years " +
                        _vm._s(_vm.formData.transferToRcMonths) +
                        " months"
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showFor("rc2ac")
            ? [
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v("When do you plan to join the Active component?"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(
                      _vm._s(_vm.formData.transferToAcYears) +
                        " years " +
                        _vm._s(_vm.formData.transferToAcMonths) +
                        " months"
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showFor("rc2ac", "rc2rc")
            ? [
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v(
                      "What is your total number of Active Service days to date?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(_vm._s(_vm.formData.activeServiceDays)),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v(
                      "How many Qualifying Years towards retirement have you earned?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(_vm._s(_vm.formData.qualifyingYears)),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v(
                      "How many retirement points in total do you have to date?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(_vm._s(_vm.formData.retirementPoints)),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("h2", [_vm._v("Retirement Information")]),
      _vm._v(" "),
      _c(
        "ul",
        [
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("Set your life expectancy"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(_vm._s(_vm.formData.lifeExpectancy) + " years"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("Set your TSP withdrawal age"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(
                _vm._s(_vm.formData.withdrawalAgeYears) +
                  " years " +
                  _vm._s(_vm.formData.withdrawalAgeMonths) +
                  " months"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("Set your TSP contribution rate"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(_vm._s(_vm.formData.contributionRate) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("Set your TSP rate of return"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(_vm._s(_vm.formData.growthRate) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v("Set your TSP rate of return at withdrawal"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(_vm._s(_vm.formData.withdrawalGrowthRate) + "%"),
            ]),
          ]),
          _vm._v(" "),
          _vm.showFor("ac2rc", "rc2ac", "rc2rc")
            ? [
                _c("li", [
                  _c("span", { staticClass: "question" }, [
                    _vm._v("Set your non-regular retirement pay age"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "answer" }, [
                    _vm._v(
                      _vm._s(_vm.formData.retirementAgeYears) +
                        " years " +
                        _vm._s(_vm.formData.retirementAgeMonths) +
                        " months"
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "question" }, [
              _vm._v(
                "Set your TSP account balance from Service Member contributions"
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "answer" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.formData.tspServiceMemberContribution,
                    "$",
                    0
                  )
                )
              ),
            ]),
          ]),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "margin-top" },
      [_c("overview-chart", { attrs: { value: _vm.overview } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "margin-top row" }, [
      _c("section", { staticClass: "col left" }, [
        _c("h1", [_vm._v("Total Retirement Package")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            '\n        The Hi-3 retirement plan also includes contributions you make to your own retirement.\n        "Total Retirement Package" includes the value of your own TSP contributions at the rate you\n        plan to invest compounded at the average annual percentage rate you projected, which is\n        shown in yellow.\n      '
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col left" },
            [
              _vm._l(_vm.totalRetirementBenefit.items, function (item) {
                return _c(
                  "div",
                  {
                    key: item.key,
                    staticStyle: { border: "solid 2px", "text-align": "right" },
                    style: { "border-color": item.bgColor },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("currency")(item.amount, "$", 0)) +
                        "\n          "
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", [
                _c("h3", { staticStyle: { "text-align": "right" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm._f("currency")(
                          _vm.totalRetirementBenefit.total,
                          "$",
                          0
                        )
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col right" },
            _vm._l(_vm.totalRetirementBenefit.items, function (item) {
              return _c(
                "div",
                { key: item.key, staticStyle: { padding: "2px" } },
                [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "col right" }, [
        _c("h1", [_vm._v("Present Value")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            '\n        "Present Value" shows the sum of all future pension and TSP payments in the year you retire\n        or separate. To determine the present value, a "discount rate" is applied to each payment you\n        will receive in the future. Doing this removes future inflation. This discount is applied\n        annually, so that money in the future is less valuable than it will be to you in the year you\n        retire or separate. You may want to consult with a financial professional for assistance\n        understanding this comparison.\n      '
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col left" },
            [
              _vm._l(_vm.presentValue.items, function (item) {
                return _c(
                  "div",
                  {
                    key: item.key,
                    staticStyle: { border: "solid 2px", "text-align": "right" },
                    style: { "border-color": item.bgColor },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("currency")(item.amount, "$", 0)) +
                        "\n          "
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", [
                _c("h3", { staticStyle: { "text-align": "right" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm._f("currency")(_vm.presentValue.total, "$", 0)
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col right" },
            _vm._l(_vm.presentValue.items, function (item) {
              return _c(
                "div",
                { key: item.key, staticStyle: { padding: "2px" } },
                [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "font-size": "0.6em" } }, [
          _vm._v(
            "\n        * Dollars represent the year in which you separate or begin to receive monthly retired pay.\n      "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "margin-top" },
      [_c("tsp-summary-chart", { attrs: { value: _vm.tspSummary } })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "margin-top" }, [
      _c("h1", [_vm._v("TSP Summary")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n      The "Summary of the TSP Account Balance" graph shows your approximate TSP account balance by calendar year by\n      the amounts you may have contributed to your TSP account. The "TSP Summary" table details the amounts you contribute\n      to your TSP account and the projected lifetime values of your TSP. The first column, "Total Contribution" shows\n      the amount that you will actually contribute to your account during your career, based on the TSP percentage\n      contribution you entered in the calculator. The second column, "Max Account Value" shows the maximum projected\n      value of your TSP account, based on the annual rate of return percentage you entered. This is the projected value\n      of your TSP account before you begin taking withdrawals during retirement. The final column, "Annualized Payment"\n      shows how much you will receive in retirement income from TSP if you were to withdraw an equal amount each year\n      from the age you indicated you would begin withdrawing ("TSP Withdrawal Age") through your estimated life expectancy age.\n    '
        ),
      ]),
      _vm._v(" "),
      _c("table", [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("Service Member TSP Contribution")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.serviceMember.totalContribution,
                    "$",
                    0
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.serviceMember.maxAccountValue,
                    "$",
                    0
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.serviceMember.annualizedPayment,
                    "$",
                    0
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("TSP Total")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.tspTotal.totalContribution,
                    "$",
                    0
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.tspTotal.maxAccountValue,
                    "$",
                    0
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.tspSummary.tspTotal.annualizedPayment,
                    "$",
                    0
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "margin-top" }, [
      _c("h1", [_vm._v("All Payments")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      This table estimates the annual military basic pay you will receive, the TSP contributions you may make from\n      your basic pay, the pension you would receive under the Hi-3 retirement plan, and the TSP payouts you would receive.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table table-condensed table-bordered table-hover" },
        [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.allPayments.columnHeadings, function (heading) {
                return _c("th", { key: heading, staticClass: "text-center" }, [
                  _vm._v(_vm._s(heading)),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.allPayments.data, function (item) {
              return _c("tr", { key: item.year }, [
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(item.calendarYear)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(item.payGrade)),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm._f("currency")(item.militaryPay, "$", 0))),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        item.serviceMemberTspContribution,
                        "$",
                        0
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(item.pensionPaymentAmount, "$", 0)
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("currency")(
                        item.tspServiceMemberPaymentAmount,
                        "$",
                        0
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm._f("currency")(item.pensionTotal, "$", 0))),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("Total Contribution"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Max Account Value")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("Annualized Payment"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "margin-top" }, [
      _c("h1", [_vm._v("Summary")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "There are many factors you should consider in the Hi-3 retirement plan. Some of these factors include:"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "How likely are you to serve for a full career of at least 20 years?"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Do you prefer investments with the potential for higher returns even if there is greater risk, or are you more\n      comfortable with conservative investments?\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Other on-line resources such as "),
        _c("a", { attrs: { href: "#" } }, [
          _vm._v("https://www.tsp.gov/index.html"),
        ]),
        _vm._v(" offer information on investing."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }